import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav-left" }
const _hoisted_2 = { class: "nav-right" }
const _hoisted_3 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass({ 'menu-open': _ctx.menuOpen, 'scrolled': _ctx.scrolled })
  }, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "/",
          onClick: _ctx.close
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("Home", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "/about",
          onClick: _ctx.close
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("About", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "/packages",
          onClick: _ctx.close
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("Packages", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createVNode(_component_router_link, {
      to: "/",
      class: "logo",
      onClick: _ctx.close
    }, {
      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
        _createTextVNode("Evelina Lodi", -1)
      ]))]),
      _: 1
    }, 8, ["onClick"]),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "/portfolio",
          onClick: _ctx.close
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("Portfolio", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "/faq",
          onClick: _ctx.close
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode("FAQ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "/contact",
          class: "inquire-btn",
          onClick: _ctx.close
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("Inquire Now", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("button", {
      class: "hamburger",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      "aria-label": _ctx.menuOpen ? 'Close menu' : 'Open menu'
    }, [...(_cache[8] || (_cache[8] = [
      _createElementVNode("span", null, null, -1),
      _createElementVNode("span", null, null, -1),
      _createElementVNode("span", null, null, -1)
    ]))], 8, _hoisted_3),
    _createElementVNode("div", {
      class: _normalizeClass(["mobile-menu", { open: _ctx.menuOpen }])
    }, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/",
            onClick: _ctx.close
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode("Home", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/about",
            onClick: _ctx.close
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("About", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/portfolio",
            onClick: _ctx.close
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("Portfolio", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/packages",
            onClick: _ctx.close
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("Packages", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/faq",
            onClick: _ctx.close
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode("FAQ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/contact",
            onClick: _ctx.close,
            class: "mobile-inquire"
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("Inquire Now", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ], 2)
  ], 2))
}